var _excluded = ["className", "NavIcon", "children", "onClick", "style", "currentSlide", "slideCount"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { srOnly } from '@domain-group/fe-brary';
import arrow from './navigation-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NavigationButton = _ref => {
  var className = _ref.className,
    NavIcon = _ref.NavIcon,
    children = _ref.children,
    onClick = _ref.onClick,
    style = _ref.style,
    currentSlide = _ref.currentSlide,
    slideCount = _ref.slideCount,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("button", _extends({
    className: className,
    style: style,
    onClick: onClick,
    type: "button"
  }, props), ___EmotionJSX(NavIcon, {
    css: arrow
  }), ___EmotionJSX("span", {
    css: srOnly
  }, children));
};
export default NavigationButton;